/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { appIconsPath } from '@utils/globalConstant';
import './Icons.scss';
export function Icons({
  name,
  width,
  height,
  alt = '',
  containerClass = '',
  colorType, // important for transformation of color in high contrast mode // use "dark" only on originally dark icons (darkgreen, gray)
  ...restProps
}) {
  const iconPath = appIconsPath[name];

  if (!iconPath) {
    // Handle the case where the icon name is not found
    return <span>404 - ICON</span>;
  }

  return (
    <span className={`app-icon ${name} ${containerClass} ${colorType}`}>
      <img src={iconPath} alt={alt} width={width} height={height} {...restProps} />
    </span>
  );
}

export default Icons;
